import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface HeaderProps {
	title?: string;
}

export function Header({ title = '' }: Readonly<HeaderProps>) {
	return (
		<Row>
			<Col span={24}>
				<S.CustomTitle>{I18n.get(title)}</S.CustomTitle>
			</Col>
		</Row>
	);
}
